/**
 * @name FileUploaderService
 * @description Servicio para la gestión de FileUploader
 * @author Alexis Becerra
 */

import axios from 'axios';
import { Environment } from '@config';

// URL Academy Endpoint
const BASE_URL = `${Environment.getCurrent().endpoints.orgChart}/Archivo`;

/**
 * Añade un archivo
 * @param {object} request
 * @return {any} promise
 */
const post = (file, fileType) => {
  const form = new FormData();
  form.append('file', file);
  form.append('fileName', file.name);

  return axios.post(`BASE_URL/${fileType}`, form).then(({ data }) => {
    return data;
  });
};

export const FileUploaderService = {
  post
};
